import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import JSONbig from 'json-bigint';
import {
  barbersLimitedReservationApiUrl,
  adminPassword,
  adminUsername,
} from '../../config';
import { UpdateBookingSlot } from '../../types/bookingSlot';
import { Booking } from '../../types/booking';
import { serializeUpdateSlotData } from './dataSerializer';

const response = [
  (data: any) => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    return data;
  },
];

export const updateShopSlot = async (
  slotId: string,
  updateData: UpdateBookingSlot
): Promise<AxiosResponse> => {
  const serializedData = serializeUpdateSlotData(updateData, {
    includeShopId: true,
  });

  const config: AxiosRequestConfig = {
    method: 'PUT',
    url: `${barbersLimitedReservationApiUrl}/shop-slots/${slotId}`,
    headers: { 'Content-Type': 'application/json' },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: serializedData,
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error updating shop slot:', error);
    throw error;
  }
};

export const updateBarberSlot = async (
  slotId: string,
  updateData: UpdateBookingSlot
): Promise<AxiosResponse> => {
  const serializedData = serializeUpdateSlotData(updateData);

  const config: AxiosRequestConfig = {
    method: 'PUT',
    url: `${barbersLimitedReservationApiUrl}/barber-slots/${slotId}`,
    headers: { 'Content-Type': 'application/json' },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: serializedData,
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error updating barber slot:', error);
    throw error;
  }
};

export const updateBooking = async (
  bookingId: string,
  booking: Booking
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'PUT',
    url: `${barbersLimitedReservationApiUrl}/bookings/${bookingId}`,
    headers: { 'Content-Type': 'application/json' },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: JSON.stringify(booking),
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error updating booking:', error);
    throw error;
  }
};
